import React from "react";
import {
  Link,
  matchPath,
  Redirect,
  Route,
  RouteComponentProps,
  Switch
} from "react-router-dom";
import purpleBackground from "./purpleBackground.svg";
import SelectWalletByHotspotPage from "./SelectWalletByHotspotPage";
import VerifyWalletWizardPage from "./VerifyWalletWizardPage";

interface Props extends RouteComponentProps<{}> {}

const VerifyWalletPage: React.FC<Props> = (props) => {
  const isSelectWalletByHotspotPage = !!matchPath(
    props.location.pathname,
    `${props.match.path}/select-wallet-by-hotspot`
  );

  return (
    <div
      className="py-4 px-8 min-h-full bg-gray-50 dark:bg-gray-700 bg-no-repeat bg-top"
      style={{
        backgroundImage: `url(${purpleBackground})`,
        backgroundSize: "calc(max(100%, 1440px))"
      }}
    >
      <nav className="flex justify-between">
        <div
          className={isSelectWalletByHotspotPage ? "flex" : "hidden md:flex"}
        >
          <Link to="/workspace/wallets">
            <img
              src="/favicon-96x96-white.png"
              width="32"
              height="32"
              alt="Hotspotty logo"
            />
          </Link>
          <span className="ml-2 text-2xl font-bold text-white">Hotspotty</span>
        </div>

        {!isSelectWalletByHotspotPage && (
          <div className="text-md sm:text-2xl font-bold text-white md:hidden">
            Wallet verification process
          </div>
        )}

        <div>
          <Link
            to="/workspace/wallets"
            className="block px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
          >
            Cancel
          </Link>
        </div>
      </nav>

      <Switch>
        <Route
          path={`${props.match.path}/select-wallet-by-hotspot`}
          component={SelectWalletByHotspotPage}
        />
        <Route
          path={`${props.match.path}/:walletAddress/:stepKey`}
          component={VerifyWalletWizardPage}
        />
        <Redirect to={`${props.match.path}/select-wallet-by-hotspot`} />
      </Switch>
    </div>
  );
};

export default VerifyWalletPage;
